import React from 'react';
import { CheckIcon, LockIcon, ShieldCheckIcon, ZapIcon } from 'lucide-react';
import { Cta } from './Cta';
import { Countdown } from './Countdown';
import { CountdownInline } from './CountdownInline';
import { plan } from '../data/planes';
export function CierreFinal() {
  return <section aria-labelledby="cierre-titulo" className="w-full bg-surface px-6 py-20" data-id="element-33" data-mp="15zojcvr0b925">
      <div className="mx-auto max-w-2xl text-center" data-id="element-34" data-mp="1620y701gx3az">
        <h2 id="cierre-titulo" className="mx-auto max-w-xl font-display text-3xl font-bold leading-tight text-ink sm:text-4xl" data-id="element-35" data-mp="iavhkinpe6zm">
          Tu mesa organizada. Tu trabajo profesional. Tu sistema listo para hoy.
        </h2>

        <p className="mt-10 text-xs font-bold uppercase tracking-[0.16em] text-brand-700" data-id="element-36" data-mp="n96r0sa36fhb">
          ⏰ El precio de lanzamiento cierra en:
        </p>
        <div className="mt-5" data-id="element-37" data-mp="23m40txjfo6pp">
          <Countdown data-id="element-38" data-mp="23p9mf2susqgo" />
        </div>
        <p className="mt-4 text-sm text-muted" data-id="element-39" data-mp="1yovgpreq5slt">Después sube el precio y no vuelve.</p>

        <div className="mt-10 overflow-hidden rounded-3xl border-2 border-brand-500 bg-canvas text-left shadow-lift" data-id="element-40" data-mp="22dhuwckyyeo8">
          <div className="flex flex-wrap items-center justify-between gap-3 bg-brand-500 px-6 py-3" data-id="element-41" data-mp="27bjfj1y1mm1t">
            <p className="text-xs font-bold uppercase tracking-[0.14em] text-ink" data-id="element-42" data-mp="2ccgwjb7bha1q">Acceso inmediato</p>
            <p className="text-xs font-bold text-ink" data-id="element-43" data-mp="2gbzfw2jhpd2g">
              Cierra en <CountdownInline data-id="element-44" data-mp="1jn07mniwoba9" />
            </p>
          </div>

          <div className="p-8 sm:p-10" data-id="element-45" data-mp="1jol0m8pknm60">
            <p className="font-display text-xl font-bold text-ink" data-id="element-46" data-mp="1oll72kqc2qxn">{plan.titulo}</p>

            <ul className="mt-6 space-y-3" data-id="element-47" data-mp="1sng8dp89l4bf">
              {plan.incluye.map(item => <li key={item} className="flex items-start gap-3" data-id="element-48" data-mp="1sllkc21p4w34">
                  <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-brand-500" data-id="element-49" data-mp="1xfpsupqm1c6b">
                    <CheckIcon className="h-3 w-3 text-white" aria-hidden="true" data-id="element-50" data-mp="10u61mj39fti6" />
                  </span>
                  <span className="text-sm leading-snug text-body" data-id="element-51" data-mp="14vhkm5rmpghe">{item}</span>
                </li>)}
            </ul>

            <div className="mt-8 border-t border-edge pt-8 text-center" data-id="element-52" data-mp="23a6iox2t1z8m">
              <div className="flex flex-wrap items-baseline justify-center gap-x-4 gap-y-2" data-id="element-53" data-mp="2hykx859l3c50">
                <span className="font-display text-2xl font-bold text-muted line-through" data-id="element-54" data-mp="2i0dxn2tlt04k">
                  {plan.precioRegular}
                </span>
                <span className="flex items-baseline gap-2 font-display text-5xl font-bold text-brand-700" data-id="element-55" data-mp="1paor69y4k7vk">
                  <span aria-hidden="true" data-id="element-56" data-mp="1kcdhbz7txxdc">🔥</span>
                  <span className="whitespace-nowrap" data-id="element-57" data-mp="1yabwv7xvzzuf">{plan.precioHoy}</span>
                </span>
              </div>

              <div className="mt-7" data-id="element-58" data-mp="1u8qkrot6fpla">
                <Cta externo className="animate-atencion" data-id="element-59" data-mp="1u7ozysmczoqd">
                  {plan.cta} →
                </Cta>
              </div>

              <ul className="mt-6 flex flex-wrap items-center justify-center gap-x-6 gap-y-2" data-id="element-60" data-mp="35o5i4tpasjgx">
                {[{
                icono: LockIcon,
                texto: 'Pago seguro'
              }, {
                icono: ZapIcon,
                texto: 'Acceso en 5 min'
              }, {
                icono: ShieldCheckIcon,
                texto: 'Garantía 7 días'
              }].map(item => <li key={item.texto} className="flex items-center gap-1.5 text-xs font-medium text-muted" data-id="element-61" data-mp="33as69x1kfp3f">
                    <item.icono className="h-3.5 w-3.5 text-brand-600" aria-hidden="true" data-id="element-62" data-mp="3893fq6ny7xl4" />
                    {item.texto}
                  </li>)}
              </ul>
            </div>
          </div>
        </div>

        <p className="mt-6 text-sm text-muted" data-id="element-63" data-mp="4tpckjdwftm1">
          Acceso inmediato · Pago único · Conversión automática a tu moneda local · Garantía de 7 días
        </p>
      </div>
    </section>;
}